import { render } from "./elem-richtext.vue?vue&type=template&id=cd1361b8&ts=true"
import script from "./elem-richtext.vue?vue&type=script&lang=ts"
export * from "./elem-richtext.vue?vue&type=script&lang=ts"

import "./elem-richtext.vue?vue&type=style&index=0&id=cd1361b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__